import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  successMessage: 'Instructor assigned successfully',
  successRemoveMessage: 'Instructor removed successfully',
  errorMessage: 'Failed to assign instructor',
  errorRemoveMessage: 'Failed to remove instructor',
  currentInstructor: 'Current instructor',
  eligibleInstructors: 'Eligible instructors',
  assignInstructor: 'Assign instructor',
  notPublished: 'To add instructors you need to publish this course',
  removeInstructor: 'Remove instructor',
  removeInstructorConfirmation:
    'Are you sure you want to remove the instructor from this course?',
};

const welsh = {
  successMessage: "Hyfforddwr wedi'i dyrannu'n llwyddiannus",
  successRemoveMessage: 'Instructor removed successfully',
  errorRemoveMessage: 'Failed to remove instructor',
  errorMessage: "Methwyd â rhoi'r hyfforddwr",
  currentInstructor: 'Hyfforddwr presennol',
  eligibleInstructors: 'Hyfforddwyr cymwys',
  assignInstructor: 'Dyrannu hyfforddwr',
  notPublished: "I ychwanegu hyfforddwyr, mae angen i chi gyhoeddi'r cwrs hwn",
  removeInstructor: 'Remove instructor',
  removeInstructorConfirmation:
    'Are you sure you want to remove the instructor from this course?',
};

export const courseInstructorText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
